module.exports = __webpack_public_path__ + "static/media/title.a0d960c8.png";